import React from "react";
import axios from 'axios';
import { Container, Row, Col } from "shards-react";
import PageTitle from "../../components/common/PageTitle";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import  api from '../common/api';
import ConfirmDialog from '../common/ConfirmDialog'
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import InputAdornment from '@material-ui/core/InputAdornment';
import Button from "@material-ui/core/Button";
import NumberFormat from 'react-number-format';

class ClientRouteCost extends React.Component {

  constructor(props) {
    super(props);
      this.state = {
        client:{},
        action:'new',
        routes:[],
        route_types:[{id:'AMBA', name:'AMBA'},{id:'Interior', name:'Interior'}],
        dialog: {sucess:0, open: false, message: '', title:'', errors:{errors:{'errors':[]}}},
        delete_dialog: {sucess:0, open: false, message: '', title:'', errors:{errors:{'errors':[]}}},
      }

  }  

  async componentDidMount() {
    var params = this.getParams();
    var client_id = params.id
    await this.getClient(client_id)
    await this.getClientRoutes(client_id)
    this.setState({loading:false, client_id: client_id})
  }

  getParams(){
    return this.props.match.params
  }  


  getClient = async(id) =>{
    const token = localStorage.getItem('userToken')
    return await axios
         .get(api.clients().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              this.setState({client: res.data[0]})
          })
          .catch(err =>{console.log(err)
          })
  }

  getClientRoutes = async(id) =>{
    const token = localStorage.getItem('userToken')
    return await axios
         .get(api.client_routes().get(id),{ headers: {"Authorization" : `Bearer ${token}`} })
          .then(res => {
              var action = (res.data.length === 0) ? 'new' : 'edit'
              var routes = (res.data.length === 0) ? [{name:'', 'up_to_km': '', cost: ''}] : res.data
              this.setState({routes: routes, action: action})
          })
          .catch(err =>{console.log(err)
          })
  }

  handleChange = (e) => {
    var element = e.target.name.split('.')
    var key = element[0]
    var id = element[1]
    var val = e.target.value.replace('$','')

    var routes = this.state.routes
    routes[id][key] = val
    this.setState({routes: routes})
  };

  handleSubmit = (event) => {
    var formData = new FormData();
    var dialog = this.state.dialog
    event.preventDefault();
    event.stopPropagation();
    let self = this
    var i = 0;
    this.state.routes.map((val,idx)=>{
      if (val.name !== ''){
        if (val.id !== undefined){
            formData.set("client_route["+i+"][id]", val.id);
        }
        formData.set("client_route["+i+"][name]", (val.name) ? val.name : '');
        formData.set("client_route["+i+"][start_date]", (val.start_date) ? val.start_date : '');
        formData.set("client_route["+i+"][end_date]", (val.end_date) ? val.end_date : '');
        formData.set("client_route["+i+"][description]", (val.description) ? val.description : '');
        formData.set("client_route["+i+"][cost]", (val.cost) ? val.cost : '');
        formData.set("client_route["+i+"][client_id]", this.state.client_id);
        //formData.set("client_route["+i+"][up_to_km]", (val.up_to_km) ? val.up_to_km : '');
        formData.set("client_route["+i+"][q_hr_normal]", (val.q_hr_normal) ? val.q_hr_normal : '');
        formData.set("client_route["+i+"][q_hr_extra]", (val.q_hr_extra) ? val.q_hr_extra : '');
        formData.set("client_route["+i+"][hour_value]", (val.hour_value) ? val.hour_value : '');
        formData.set("client_route["+i+"][hour_extra_value]", (val.hour_extra_value) ? val.hour_extra_value : '');
        formData.set("client_route["+i+"][hotel]", (val.hotel) ? val.hotel : '');
        formData.set("client_route["+i+"][taxi]", (val.taxi) ? val.taxi : '');
        formData.set("client_route["+i+"][viatic]", (val.viatic) ? val.viatic : '');
        formData.set("client_route["+i+"][fuel]", (val.fuel) ? val.fuel : '');
        formData.set("client_route["+i+"][tool]", (val.tool) ? val.tool : '');
        formData.set("client_route["+i+"][tickets]", (val.tickets) ? val.tickets : '');
        formData.set("client_route["+i+"][others]", (val.others) ? val.others : '');
        formData.set("client_route["+i+"][additional]", (val.additional) ? val.additional : '');
        i++;
      }
    })
    const token = localStorage.getItem('userToken')
    if (this.state.action ==='new'){
        axios.post(api.client_routes().post(),
           formData,
           {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
           )
          .then((response)=> {
              dialog.title = 'Costos cliente'
              dialog.success = 1
              dialog.message = 'Costos creados con éxito!'
              dialog.open = true
              self.setState({dialog: dialog})
          })
          .catch(function (error) {
              dialog.title = 'Costos cliente'
              dialog.message = 'Ha ocurrido un error!'
              dialog.open = true
              dialog.success = 0
              var promise = new Promise(function(resolve, reject) {
                resolve(error.response.data);
                dialog.errors = error.response.data         
              });
              self.setState({dialog: dialog})
        })
    } else {
      formData.append('_method', 'patch');
      axios.post(api.client_routes().patch(this.state.client_id),
         formData,
         {headers: {'Content-Type': 'multipart/form-data',"Authorization" : `Bearer ${token}`}}
         )
        .then((response)=> {
              dialog.title = 'Costos cliente'
              dialog.success = 1
              dialog.open = true
              dialog.message = 'Costos modificados con éxito!'
              self.setState({dialog: dialog})
        })
        .catch(function (error) {
          dialog.title = 'Costos cliente'
          dialog.open = true
          dialog.message = 'Ha ocurrido un error!'
          dialog.success = 0
          var promise = new Promise(function(resolve, reject) {
            resolve(error.response.data);
            dialog.errors = error.response.data         
          });
          self.setState({dialog: dialog})
      })

    }
  }

  handleDialogClose = () => {
    var dialog = this.state.dialog
    dialog.open = false
    dialog.errors = []
    var delete_dialog = this.state.delete_dialog
    delete_dialog.open = false
    delete_dialog.errors = []
    this.setState({dialog: dialog, delete_dialog: delete_dialog})
  }

  handleDialogAccept = () =>{
    if (this.state.dialog.success === 1){
        window.location.href='/clients'
    } else {
      this.handleDialogClose()
    }
  }

  handleDialogCancel = () =>{
    this.handleDialogClose()
  }


  handleCancelButton = () => {
    window.location.href='/clients'
  }

  handleNewRoute = (e) => {
    e.preventDefault()
    var routes = this.state.routes
    routes.push({name:'', 'up_to_km': '', cost: '', description:'', q_hr_normal:'',q_hr_extra:'',hour_value:'',tickets:'',fuel:'',tool:'',taxi:'',hotel:'',viatic:'',others:'',additional:'',hour_extra_value:''})
    this.setState({routes: routes})
  }

  handleRemoveRoute = (e,id) => {
    e.preventDefault()
    var delete_dialog = this.state.delete_dialog
    delete_dialog.title = 'Costos cliente'
    delete_dialog.success = 0
    delete_dialog.message = 'Esta seguro de eliminar el costo?'
    delete_dialog.open = true
    this.setState({delete_dialog: delete_dialog, delete_id: id})
  }

  handleDelete = async () => {
    var id = this.state.delete_id
    var routes = this.state.routes
    var delete_dialog = this.state.delete_dialog
    var route = {}
    routes.map((val,idx)=>{
        if (idx === id){
          route = val
        }
    })
    if (route.id !== undefined){
      let self = this
      const token = localStorage.getItem('userToken')
      await axios.delete(api.client_routes().delete(route.id),{ headers: {"Authorization" : `Bearer ${token}`}},
          )
        .then((response)=> {
          routes = routes.filter((s, sidx) => id !== sidx);
          delete_dialog.title = 'Costos cliente'
          delete_dialog.success = 1
          delete_dialog.open = true
          delete_dialog.message = 'Costos eliminados con éxito!'
        })
        .catch(function (error) {
          delete_dialog.title = 'Costos cliente'
          delete_dialog.success = 1
          delete_dialog.open = true
          delete_dialog.message = 'Ha ocurrido al eliminar el costo. Contact a su administrador!'
          self.setState({delete_dialog: delete_dialog})
          console.log(error)
        })
    } else {
      delete_dialog.title = 'Costos cliente'
      delete_dialog.success = 1
      delete_dialog.open = true
      delete_dialog.message = 'Costos eliminados con éxito!'
      routes = routes.filter((s, sidx) => id !== sidx);
    }
    this.setState({routes: routes, delete_dialog: delete_dialog})
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
       MuiInput: {
          underline: {
              '&:before': {
                borderBottom: '0px',
              }
          }
        },
        MuiTypography:{
          caption:{
            fontWeight: 600
          }
        },
        MuiInputBase:{
          input:{
            borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
          }
        } 
    }
  });     

  render() {
    return (
      <MuiThemeProvider theme={this.getMuiTheme()}>

      <React.Fragment>
        <Container fluid className="main-content-container px-4 position-relative">
        {(!this.state.loading)
          ? 
            <React.Fragment>
              <ConfirmDialog 
                      confirm_dialog={this.state.delete_dialog.open} 
                      title={this.state.delete_dialog.title}
                      message={this.state.delete_dialog.message}
                      onClose={this.handleDialogClose} 
                      onAccept={this.handleDelete}
                      onCancel={this.handleDialogCancel}
                      errors={this.state.delete_dialog.errors}
                />

              <ConfirmDialog 
                      confirm_dialog={this.state.dialog.open} 
                      title={this.state.dialog.title}
                      message={this.state.dialog.message}
                      onClose={this.handleDialogClose} 
                      onAccept={this.handleDialogAccept}
                      onCancel={this.handleDialogCancel}
                      errors={this.state.dialog.errors}
                />
              <Row noGutters className="page-header">
                  <Typography variant="h6">Costos de Valet {this.state.client.business_name}</Typography>
              </Row>
              {(this.state.routes.map((val, idx)=>{
                var disabled = (val.deleted_at) ? true : false
                return (
                  <React.Fragment>
                    <Row className="ml-1 mt-2">
                      <Typography variant="subtitle1">Ruta {(disabled) ? 'Inactivo' : '' }</Typography>
                    </Row>
                    <Row className="ml-1 mt-1">
                      <TextField
                        id={"name."+idx}
                        name={"name."+idx}
                        disabled={disabled}
                        select
                        margin="normal"
                        className="mr-2 mt-1"
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={this.handleChange}
                        value={val.name}
                        inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 75}}>Tipo de ruta</Typography></InputAdornment>,
                            style:{fontSize: '0.75rem'}
                        }}
                        >
                        {this.state.route_types.map((option) => (
                        <MenuItem key={option.id} value={option.id} style={{fontSize: '0.75rem'}}>
                          {option.name}
                        </MenuItem>
                      ))}
                      </TextField>
                      <TextField
                        id={"description."+idx}
                        name={"description."+idx}
                        type="text"
                        disabled={disabled}
                        margin="normal"
                        className="mr-2 mt-1"
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={this.handleChange}
                        value={val.description}
                        inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 75}}>Descripción</Typography></InputAdornment>,
                            style:{fontSize: '0.75rem'}
                        }}
                        />
                      <TextField
                        id={"start_date."+idx}
                        name={"start_date."+idx}
                        type="date"
                        disabled={disabled}
                        margin="normal"
                        className="mr-2 mt-1"
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={this.handleChange}
                        value={val.start_date}
                        inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 75}}>Fecha desde</Typography></InputAdornment>,
                            style:{fontSize: '0.75rem'}
                        }}
                        />          
                      <TextField
                        id={"end_date."+idx}
                        name={"end_date."+idx}
                        type="date"
                        disabled={disabled}
                        margin="normal"
                        className="mr-2 mt-1"
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={this.handleChange}
                        value={val.end_date}
                        inputProps={{style:{minWidth: 70, fontSize: '0.75rem'}}}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" style={{width: 75}}>Fecha hasta</Typography></InputAdornment>,
                            style:{fontSize: '0.75rem'}
                        }}
                        />                        
                      <NumberFormat 
                        id={"cost."+idx}
                        name={"cost."+idx}
                        disabled={disabled}
                        value={val.cost}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {minWidth: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Costo</Typography></InputAdornment>,
                            style:{fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue > 0 && floatValue < 99999999;
                        }}            

                        />     

{/*
                      <TextField
                        id={"cost."+idx}
                        name={"cost."+idx}
                        type="number"
                        margin="normal"
                        className="mr-2 mt-1"
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={this.handleChange}
                        value={val.cost}
                        inputProps={{style:{width: 50, fontSize: '0.75rem'}}}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Costo</Typography></InputAdornment>,
                        }}
                      />
*/}
{/*                      <TextField
                        id={"up_to_km."+idx}
                        name={"up_to_km."+idx}
                        margin="normal"
                        type="number"
                        className="mr-2 mt-1"
                        InputLabelProps={{
                          shrink: true
                        }}
                        onChange={this.handleChange}
                        value={val.up_to_km}
                        inputProps={{style:{width: 50, fontSize: '0.75rem'}}}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Hasta KM</Typography></InputAdornment>,
                        }}
                      />
*/}
                      <IconButton disabled={(this.state.routes.length === 1 && disabled) ? false : disabled} size="small">
                        <AddIcon disabled={(this.state.routes.length === 1 && disabled) ? false : disabled} onClick={(e)=> {this.handleNewRoute(e)}} />
                      </IconButton>
                      <IconButton disabled={disabled} size="small">
                        <RemoveIcon disabled={disabled} onClick={(e) => {this.handleRemoveRoute(e,idx)}} />
                      </IconButton>
                    </Row>
                    <Row className="ml-1 mt-1">
                      <Typography variant="subtitle1">Detalle</Typography>
                    </Row>
                    <Row className="ml-1 mt-1">
                      <NumberFormat 
                        id={"hour_value."+idx}
                        name={"hour_value."+idx}
                        disabled={disabled}
                        value={val.hour_value}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Valor hr</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          
                      <NumberFormat 
                        id={"hour_extra_value."+idx}
                        name={"hour_extra_value."+idx}
                        disabled={disabled}
                        value={val.hour_extra_value}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Valor hr extra</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          
                      <NumberFormat 
                        id={"q_hr_normal."+idx}
                        name={"q_hr_normal."+idx}
                        value={val.q_hr_normal}
                        disabled={disabled}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={''}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Cant. Hs</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          
                      <NumberFormat 
                        id={"q_hr_extra."+idx}
                        name={"q_hr_extra."+idx}
                        value={val.q_hr_extra}
                        disabled={disabled}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={''}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Cant. Hs Extra</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          
                      <NumberFormat 
                        id={"fuel."+idx}
                        name={"fuel."+idx}
                        value={val.fuel}
                        disabled={disabled}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Combustible</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          
                      <NumberFormat 
                        id={"taxi."+idx}
                        name={"taxi."+idx}
                        value={val.taxi}
                        disabled={disabled}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Taxi</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          
                      <NumberFormat 
                        id={"tool."+idx}
                        name={"tool."+idx}
                        value={val.tool}
                        disabled={disabled}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Peaje</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          
                      <NumberFormat 
                        id={"hotel."+idx}
                        name={"hotel."+idx}
                        value={val.hotel}
                        disabled={disabled}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Hospedaje</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          
                      <NumberFormat 
                        id={"viatic."+idx}
                        name={"viatic."+idx}
                        value={val.viatic}
                        disabled={disabled}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Viaticos</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          
                      <NumberFormat 
                        id={"tickets."+idx}
                        name={"tickets."+idx}
                        value={val.tickets}
                        disabled={disabled}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Pasajes</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          

                      <NumberFormat 
                        id={"others."+idx}
                        name={"others."+idx}
                        value={val.others}
                        disabled={disabled}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Otros</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          

                      <NumberFormat 
                        id={"additional."+idx}
                        name={"additional."+idx}
                        value={val.additional}
                        disabled={disabled}
                        onChange={this.handleChange}
                        className="mr-2 mt-1"
                        InputProps={{style: {width: 70,fontSize: '0.75rem'}}}
                        decimalSeparator='.'
                        prefix={'$'}
                        customInput={TextField}  
                        InputLabelProps={{
                          shrink: true,
                        }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" ><Typography variant="caption" >Adicionales</Typography></InputAdornment>,
                            style:{width: 120, fontSize: '0.75rem'}
                        }}
                        isAllowed={(values) => {
                          let { floatValue } = values;
                          floatValue = (floatValue !== undefined) ? floatValue : 0
                          return floatValue >= 0 && floatValue < 99999999;
                        }}            

                        />                          

                    </Row>
                  </React.Fragment>
                )
              }))}
              <Button className="mr-1 mt-3" variant="contained" color="primary" onClick={(e)=>{this.handleSubmit(e)}} style={{fontSize: '0.7rem'}}>
                Guardar
              </Button>
              <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/clients"} style={{fontSize: '0.7rem'}}>
                Cancelar
              </Button>

            </React.Fragment>
          :
            <LinearProgress />          
        }
        </Container>
      </React.Fragment>
      </MuiThemeProvider>

    )
  }
}

export default ClientRouteCost;